import React, { useState, useEffect } from "react"
import TextareaAutosize from "react-textarea-autosize"
import TextareaIndicator from "./textarea-indicator"
import ReactQuill from "react-quill"
import "react-quill/dist/quill.snow.css"

import "./textarea.scss"

const TextArea = props => {
  const [focus, setFocus] = useState(false)
  const [editorHeight, setEditorHeight] = useState("200px")

  // const quillModules = {
  //   toolbar: [
  //     ['bold', 'italic', 'underline', 'strike'],        // options for the toolbar
  //     ['link', 'image', 'video'],                        // options for the toolbar
  //     [{ 'header': [1, 2, 3, 4, 5, 6, false] }],          // options for the toolbar
  //     [{ 'font': [] }],
  //     [{ 'align': [] }],
  //     [{ 'color': [] }, { 'background': [] }],           // options for the toolbar
  //     ['clean']                                         // options for the toolbar
  //   ],
  //   // Other Quill options
  //   // For example, you can set the editor's height:
  //   // height: '500px'
  // };

  const handleChange = e => {
    if (props?.editor) {
      props.onChange(e)
      return
    }
    if (e.target.value.length <= props.total) {
      props.onChange(e.target.value)
    }
    return
  }

  const onFocus = () => {
    props.onFocus()
    setFocus(true)
  }
  const onBlur = () => {
    setFocus(false)
  }

  useEffect(() => {
    const editor = document.querySelector(".ql-editor")
    if (editor) {
      const newHeight = `${editor.scrollHeight}px`
      setEditorHeight(newHeight)
    }
  }, [props.value])

  return (
    <div className={`form-group mb-4  ${props.class}`}>
      <label htmlFor={`${props.name}`}>{props.label}</label>
      {props?.editor && typeof document !== "undefined" ? (
        <div>
          <ReactQuill
            value={props.value}
            onChange={content => handleChange(content)}
            // style={{ height: editorHeight }}
            placeholder={props.placeholder}
          />
        </div>
      ) : props.autosize ? (
        <>
          <TextareaAutosize
            onChange={handleChange}
            value={props.value}
            placeholder={props.placeholder}
            onFocus={onFocus}
            onBlur={onBlur}
            minRows={7}
            maxRows={focus ? undefined : 7}
          />
          <TextareaIndicator value={props.value} total={props.total} />
        </>
      ) : (
        <textarea
          className="form-control"
          rows={props.rows | 4}
          type={props.type}
          onChange={props.onChange}
          onFocus={props.onFocus}
          placeholder={props.placeholder}
          name={props.name}
          defaultValue={props.value}
        />
      )}
    </div>
  )
}

export default TextArea
